import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const VideoPlayerStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [breakpoints.down('xs')]: {
      height: 'auto',
      display: 'block',
    },
  },

  rootMobile: {
    width: '100%',
    // height: '100%',
    // display: 'flex',
    alignItems: 'center',

    height: 'auto !important',
    maxHeight: '100% !important',
    display: 'block',
    [breakpoints.down('xs')]: {
      height: 'auto',
      display: 'block',
    },
  },
  playerContainer: {
    maxHeight: '100%',
    height: '100%',
    width: '100%',
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
  },
  videoJs: {
    '& .video-js, .vjs-poster': {
      backgroundColor: 'unset',
    },
    '& .vjs-poster': {
      // height: '100vh',
      // maxHeight: 'inherit',
    },
    '& .vjs-big-play-button, .vjs-remaining-time': {
      display: 'none',
    },
    '& .vjs-control-bar button': {
      outline: 'unset',
      textShadow: 'unset',
      color: '#263245',
      '& .vjs-icon-placeholder:before': {
        fontSize: 25,
        lineHeight: 1.2,
      },
    },
    '& .vjs-current-time, .vjs-time-divider, .vjs-duration': {
      display: 'block',
    },
    '& .vjs-current-time, .vjs-duration': {
      padding: 0,
    },
    '& .vjs-time-divider': {
      padding: '0 3px',
      minWidth: 'unset',
    },
    '& .vjs-play-control, .vjs-fullscreen-control, .vjs-volume-panel, .vjs-remaining-time, .vjs-current-time, .vjs-button, .vjs-time-divider, .vjs-duration': {
      color: '#263245',
    },
    '& .vjs-control-bar': {
      backgroundColor: '#FFF',
      boxShadow: '0 -4px 4px 0 rgba(0,0,0,0.25)',
      display: 'flex',
    },
    '& .vjs-play-progress': {
      color: '#F1F2F5',
      borderRadius: 6,
      backgroundColor: palette.player.trackValueBackground,
      '&::before': {
        fontSize: 14,
        top: -3,
      },
    },
    '& .vjs-progress-holder': {
      height: 8,
      borderRadius: 6,
      backgroundColor: palette.player.trackBackground,
    },
    '& .vjs-load-progress': {
      borderRadius: 6,
      '& > div': {
        backgroundColor: 'rgba(81,91,106,0.1)',
      },
    },
    '& .vjs-volume-level': {
      color: '#F1F2F5',
      height: 8,
      borderRadius: 6,
      backgroundColor: palette.player.trackValueBackground,
      '&::before': {
        fontSize: 14,
        top: -3,
      },
    },
    '& .vjs-volume-bar': {
      backgroundColor: palette.player.trackBackground,
      height: 8,
      borderRadius: 6,
      margin: 0,
      top: 11,
    },
    '& video': {
      background: 'transparent',
      // height: 'auto !important',
      maxHeight: '100%',
      '&:focus': {
        outline: 'unset',
      },
    },
  },
  mobilePlayer: {
    maxHeight: 'inherit',

    '& .vjs-control-bar': {
      background: 'transparent',
      zIndex: 1,
      boxShadow: 'none',
      margin: '0 auto 10px',
      width: '90%',
    },

    '& span': {
      color: '#FFF',
      fontSize: 12,
    },

    '& .vjs-volume-panel, .vjs-play-control, .vjs-picture-in-picture-control': {
      display: 'none',
    },

    '& .vjs-progress-holder': {
      background: '#FFF',
      height: 6,
    },

    '& .vjs-load-progress': {
      background: '#01B3C5',
      opacity: '0.2',
    },

    '& .vjs-progress-control': {
      marginLeft: '10px',
    },

    '&.vjs-fullscreen .vjs-control-bar': {
      paddingLeft: 12,
      background: 'rgba(28,38,71,0.3) !important',
      borderRadius: 6,
    },

    '& .vjs-slider-bar::before': {
      top: '-7px',
      fontSize: 20,
    },

    '& .vjs-tech': {
      position: 'relative',
      top: 'unset',
      left: 'unset',
      bottom: 'unset',
      right: 'unset',
      maxHeight: 'inherit',
    },
  },
}), { name: 'VideoPlayer' });
